import { ICrmEmbedBlock } from 'source/NFR.types';

const CrmEmbedBlock: React.FC<ICrmEmbedBlock> = ({ src }) => {
  return <div dangerouslySetInnerHTML={{ __html: src }}></div>;
};

CrmEmbedBlock.displayName = 'CrmEmbedBlock';

export default CrmEmbedBlock;
